
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import EditSVG from '@/components/EditSVG.vue';
	import ExpandSVG from '@/views/saved-rx-list/components/ExpandSVG.vue';
	import EndViewCategory from '@/components/prescription/EndViewCategory.vue';
	import { SavedRxName } from '@/store/engine/openapi/generated';
	import UtilsStore from '@/store/utilsStore';
	import PrescriptionSummary from '@/components/new-prescription/prescription-summary/PrescriptionSummary.vue';
	import PrescriptionSummaryCategory from '@/components/new-prescription/prescription-summary/PrescriptionSummaryCategory.vue';

	@Observer
	@Component({
		components: {
			EndViewCategory,
			EditSVG,
			ExpandSVG,
			PrescriptionSummary,
			PrescriptionSummaryCategory
		}
	})
	export default class SavedRxListItem extends Vue {
		@Prop({ required: true }) savedRx?: SavedRxName;
		@Prop({ required: false, default: { selectable: false } }) selectable?: boolean;
		private prescriptionItem: any = null;
		private corruptedPrescription = false;

		public async activated() {
			if (this.$router.currentRoute.query.prescription && this.savedRx && this.savedRx.fileName === this.$router.currentRoute.query.prescription) {
				const pres = await this.$engine.savedRx.getRx(this.savedRx.fileName, this.savedRx.companyID);
				if (pres?.fileData) {
					this.prescriptionItem = JSON.parse(pres.fileData);
					this.$state.prescription.newPrescription = JSON.parse(pres.fileData);
				}
			}
		}

		private async dropDownPreview() {
			if (!this.prescriptionItem) {
				if (this.savedRx?.fileName) {
					const pres = await this.$engine.savedRx.getRx(this.savedRx.fileName, this.savedRx.companyID);
					if (pres?.fileData) {
						try {
							this.prescriptionItem = JSON.parse(pres.fileData);
							this.$state.prescription.newPrescription = JSON.parse(pres.fileData);
						} catch (e) {
							console.error(e);
							this.corruptedPrescription = true;
							this.prescriptionItem = `Prescription ${this.savedRx.fileName} is corrupted`;
						}
					}
				}
			} else {
				this.prescriptionItem = null;
			}
		}

		private select() {
			this.$emit('selectRX', this.savedRx);
		}

		private formatDate(isoString: string) {
			try {
				if (!UtilsStore.isIsoDate(isoString)) {
					return 'Provided date is not valid iso string';
				}
				const d = new Date(isoString);
				if ([d.getMonth(), d.getDate(), d.getFullYear()].some((d) => isNaN(d))) {
					return 'Some of values are not numbers';
				}
				return d.getMonth() + 1 + '.' + d.getDate() + '.' + d.getFullYear();
			} catch (e) {
				return 'Corrupted iso date string';
			}
		}

		private async edit() {
			if (this.selectable) {
				this.select();
				return;
			}
			if (this.savedRx?.fileName) {
				let query = { name: this.savedRx?.fileName };
				if (this.savedRx.companyID) {
					Object.assign(query, { companyID: this.savedRx.companyID });
				}
				await this.$router.push({ path: '/saved-rx', query });
			}
		}

		private isOrthoticStyle() {
			return this.$router.currentRoute.name === 'Orthotic Styles';
		}
	}
